import staticEndPoints from "./staticEndpoints";
import apiEndpoints from "./apiEndpoints";
import overwatchEndPoint from "./overwatchEndPoint";

const apis = {
  ...staticEndPoints,
  ...apiEndpoints,
  ...overwatchEndPoint,
};
export default apis;



// WEBPACK FOOTER //
// ./src/api/endPoints/index.js